export default __webpack_public_path__ + "static/media/veronika_m.5033d01a.jpg";